import { render, staticRenderFns } from "./loginParameterSwitching.vue?vue&type=template&id=08649232&scoped=true&"
import script from "./loginParameterSwitching.vue?vue&type=script&lang=js&"
export * from "./loginParameterSwitching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08649232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08649232')) {
      api.createRecord('08649232', component.options)
    } else {
      api.reload('08649232', component.options)
    }
    module.hot.accept("./loginParameterSwitching.vue?vue&type=template&id=08649232&scoped=true&", function () {
      api.rerender('08649232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/loginParameterSwitching.vue"
export default component.exports